import { PRODUCT_NOTES } from '~/lib/constants'

import { PRODUCT } from '~/data/dictionary'

export function getProductNoteFromProductState({
  isVariantAdjusting,
  isVariantSellable,
  isStockAlert,
  isOutOfStock,
  isSpecialOrder,
  isPreOrder,
}): string {
  if (isVariantSellable && isVariantAdjusting) {
    return PRODUCT_NOTES.ADJUSTABLE_FROM_SIZE_FOUND
  }

  if (!isVariantSellable && isVariantAdjusting && !isPreOrder) {
    return PRODUCT_NOTES.NOT_ADJUSTABLE
  }

  if (isStockAlert && isOutOfStock) {
    return PRODUCT_NOTES.STOCK_ALERT
  }

  if (isSpecialOrder && isOutOfStock) {
    return PRODUCT_NOTES.SPECIAL_ORDER
  }

  if (isPreOrder) {
    return PRODUCT_NOTES.PRE_ORDER
  }

  return null
}

export function getProductTextFromProductState({
  isAdjusting,
  isThreeSizesVariants,
  isVariantAdjusting,
  isVariantSellable,
  isOutOfStock,
  isSpecialOrder,
}) {
  if (isAdjusting) {
    if (isVariantSellable && isVariantAdjusting) {
      return PRODUCT.SIZE_ADJUSTABLE
    }

    if (!isVariantSellable && isVariantAdjusting) {
      return PRODUCT.SIZE_ADJUSTABLE_NOT_POSSIBLE
    }
  } else {
    if (isOutOfStock) {
      if (isSpecialOrder) {
        return PRODUCT.SPECIAL_ORDER
      }

      return PRODUCT.SOLDOUT
    }

    if (isThreeSizesVariants) {
      return PRODUCT.SIZE_THREE
    }
  }

  return PRODUCT.SIZE_AVAILABLE
}
